import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../nodeIds';

export const insuredTotalLifeCoverageExcludingWorkGroupBenefits: AnswerPathTreeNode = {
  path: 'insuredTotalLifeCoverageExcludingWorkGroupBenefits',
  nodeId: NodeIds.insuredTotalLifeCoverageExcludingWorkGroupBenefits,
};
